<template>
  <online-school-klass :page-class="11" />
</template>

<script>
import OnlineSchoolKlass from '../5-klass/index.vue';

export default {
  name: 'OnlineSchool11Klass',
  components: {
    OnlineSchoolKlass,
  },
  layout: 'DefaultLayoutV2',
};
</script>
